
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5d9f6a55\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../vue-loader/lib/selector?type=styles&index=0!./Notification.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Notification.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5d9f6a55\"}!../../vue-loader/lib/selector?type=template&index=0!./Notification.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-notification/src/Notification.vue
// module id = 4
// module chunks = 40